import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { type Observable, map } from 'rxjs';
import { API_BASE_URL } from '@shared/http';
import {
  NavHistorySchema,
  VaultActivitySchema,
  VaultLockTiersSchema,
  VaultOverviewSchema,
  VaultPositionSchema,
  VaultTradesSchema,
  type NavHistoryItem,
  type VaultActivity,
  type VaultLockTier,
  type VaultOverview,
  type VaultPosition,
  type VaultTrades,
} from '../model/vault-position.schema';

@Injectable({ providedIn: 'root' })
export class VaultPositionApi {
  private readonly http = inject(HttpClient);
  private readonly base = inject(API_BASE_URL);

  overview$(): Observable<VaultOverview> {
    return this.http
      .get<unknown>(`${this.base}/vault/overview`)
      .pipe(map(raw => VaultOverviewSchema.parse(raw)));
  }

  lockTiers$(): Observable<VaultLockTier[]> {
    return this.http
      .get<unknown>(`${this.base}/vault/lock-tiers`)
      .pipe(map(raw => VaultLockTiersSchema.parse(raw)));
  }

  myPosition$(): Observable<VaultPosition> {
    return this.http
      .get<unknown>(`${this.base}/vault/my-position`)
      .pipe(map(raw => VaultPositionSchema.parse(raw)));
  }

  navHistory$(period: string): Observable<NavHistoryItem[]> {
    return this.http
      .get<unknown>(`${this.base}/vault/nav-history`, { params: { period } })
      .pipe(map(raw => NavHistorySchema.parse(raw)));
  }

  tradesList$(limit = 20, offset = 0): Observable<VaultTrades> {
    return this.http
      .get<unknown>(`${this.base}/vault/trades`, { params: { limit, offset } })
      .pipe(map(raw => VaultTradesSchema.parse(raw)));
  }

  myActivity$(limit = 20, offset = 0): Observable<VaultActivity> {
    return this.http
      .get<unknown>(`${this.base}/vault/my-activity`, { params: { limit, offset } })
      .pipe(map(raw => VaultActivitySchema.parse(raw)));
  }
}
